import React, { Component } from "react";
export default class Resume extends Component {
  render() {
    return (
      <React.Fragment>
        <section id="resume">
          <div className="row education">
            <div className="three columns header-col">
              <h1>
                <span>Education</span>
              </h1>
            </div>
            <div className="nine columns main-col">
              <div className="row item">
                <div className="twelve columns">
                  <h3>Asia Pacific College</h3>
                  <p className="info">
                    Bachelor of Science in Computer Engineering <span>•</span>{" "}
                    <em className="date">May 2015</em>
                  </p>
                  <p>
                    Deans Lister - 2011 | SM Foundation Scholar - Full
                    Scholarship
                  </p>
                </div>
              </div>

              <div className="row item">
                <div className="twelve columns">
                  <h3>Paranaque National Highschool (DOST)</h3>
                  <p className="info">
                    Science Highschool <span>•</span>{" "}
                    <em className="date">2010</em>
                  </p>
                  <p />
                </div>
              </div>
            </div>
          </div>

          <div className="row work">
            <div className="three columns header-col">
              <h1>
                <span>Work</span>
              </h1>
            </div>
            <div className="nine columns main-col">
              <div className="row item">
                <div className="twelve columns">
                  <h3>Orient Overseas Container Lines (OOCL)</h3>
                  <p className="info">
                    Software Engineer <span>•</span>{" "}
                    <em className="date">March 2015 - Present</em>
                  </p>
                  <p>
                    OOCL is one of the world's largest integrated international
                    container transportation, logistics and terminal companies.
                    I've been a developer and support for their enterprise
                    software and been trained overseas.
                  </p>
                </div>
              </div>
              <div className="row item">
                <div className="twelve columns">
                  <h3>SM Prime Holdings, Inc.</h3>
                  <p className="info">
                    Tech Support and System Developer (Intern)<span>•</span>{" "}
                    <em className="date">May 2014 - December 2014</em>
                  </p>
                  <p>
                    The SM Prime Holdings, Inc or SM Prime is the parent company
                    of the SM Group's shopping malls in the Philippines. I've
                    been a technical support originally for 1 month and then
                    switched to System Developer for the remaining months.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row skill">
            <div className="three columns header-col">
              <h1>
                <span>Skills</span>
              </h1>
            </div>
            <div className="nine columns main-col">
              <p>
                This is just some of my skills which I rated personally. For
                other skills, please see my attached resume in the About Me{" "}
              </p>
              <div className="bars">
                <ul className="skills">
                  <li>
                    <span className="bar-expand laravel" />
                    <em>Laravel</em>
                  </li>
                  <li>
                    <span className="bar-expand react" />
                    <em>React</em>
                  </li>
                  <li>
                    <span className="bar-expand vue" />
                    <em>Vue 2</em>
                  </li>
                  <li>
                    <span className="bar-expand angular" />
                    <em>Angular 1.6</em>
                  </li>
                  <li>
                    <span className="bar-expand node" />
                    <em>Node</em>
                  </li>

                  <li>
                    <span className="bar-expand jquery" />
                    <em>jQuery</em>
                  </li>
                </ul>
              </div>
            </div>{" "}
          </div>
        </section>
      </React.Fragment>
    );
  }
}
